import { UTCTime } from '@rootTypes/utils/common/date';

export const getRideStartDateLong = (startTimestamp: number, timezone: string): string => {
  const formatter = new UTCTime(startTimestamp, timezone);
  return formatter.getDisplayWeekdayAndDateStr();
};
